import $ from 'jquery';
import constants from 'Constants.js';
import BaseTableView from 'properties/BaseTableView.js'
import { View } from 'backbone';
import {Model} from 'backbone';
import util             from 'util/Util.js';
import listService      from 'ListService.js';
import undoService      from 'UndoService.js';
import sequenceService from 'SequenceService.js';
import SelectFieldModal from 'common-views/SelectFieldModalView.js';
import FormulaModal from 'common-views/MainFormulaModalView';
import Template from 'properties/main/custom-parameters.ejs';
import textConstants from "../../../constants/TextConstants";


class MainCustomParametersView extends BaseTableView {


    initialize( opts ) {
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE;


        this.events = {
            "click .itemNew"              : "itemNew",
            "click .itemRemove"           : "itemRemove",
            "click .itemUp"               : "itemUp",
            "click .itemDown"             : "itemDown",
            "change input[type=checkbox]" : "itemCheck"
        };

        const hideNameColumn = (this.model.get('factoryKey') === 'command_call_javascript')

        this.model.set({
            colModel: [
                {
                    name: 'name',
                    index: 'name',
                    editable: true,
                    hidden: hideNameColumn
                },
                {
                    name: 'source',
                    index: 'source',
                    editable: false
                },
                {
                    name: 'formula',
                    index: 'formula',
                    edittype: 'checkbox',
                    editoptions: { value:"selected" },
                    formatter: "checkbox",
                    formatoptions: { disabled: false}
                },
                {
                    name: 'isDefault',
                    index: 'isDefault',
                    editable: false,
                    hidden: true
                }
            ],
            colNames: ['Name', 'Source', 'Formula', 'isDefault']
        }, {silent: true});


        this.loadDataFromCustomParameters();

        this.listenTo(this.model, 'change',this.render);
        this.onResize();
        return this;
    }

    loadDataFromCustomParameters() {
        this.model.set('gridData', [], {silent: true});
        const parameters = !this.model.attributes.CustomParameters.parameter ? [] : this.model.attributes.CustomParameters.parameter;

        let gridData = this.model.get('gridData');
        let objName = '';

        for (let param of parameters) {
            objName = '';
            if (param._value) {
                const id = param._value;
                objName = listService.determineFieldName(id);
            }

            let newRow = {
                'name': param._name,
                'source': param._type === 'expression' ? '[Formula]' : objName,
                'formula': param._type === 'expression' ? 'selected' : ''
            };
            gridData.push(newRow);
        }

        if (parameters.length < 5){
            let emptyRow = {
                'name': '',
                'source': '',
                'formula': '',
                'isDefault': true
            };
            for (let i= parameters.length; i<5; ++i){
                gridData.push(emptyRow);
            }
        }

        this.model.set('gridData', gridData, {silent: true});
    }

    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).on('resize',() => {this.resizeGrid(); util.makePanelFit();})
    }

    onCellSelect(rowId, iCol, cellcontent, e) {
        this.model.unset('newRowAdded', constants.MODEL_SILENT);
        util.saveGridScrollPos(this.model);

        const rowData = $(this.gridEl).getRowData(rowId);
        if (rowData['isDefault']) {
            return;
        }

        const colNames = this.model.get('colNames');
        if (colNames[iCol] !== 'Source' ) {
            return;
        }

        let rowIdModel=parseInt(rowId);
        let gridData = this.model.get('gridData');
        console.log('Current Grid Data',gridData);
        console.log('Current Grid Data Row',gridData[rowIdModel]);
        if (gridData[rowIdModel].formula === 'selected') {
            console.log('Formula Modal Opened');
            let attributes = {formulaParameter: this.model.attributes.CustomParameters.parameter[rowIdModel].Expression };

            var sfModel = new Model(attributes);
            sfModel.set("dataSelectedItemId", this.model.attributes.CustomParameters.parameter[rowIdModel]._value, {silent:true});
            
            let sfModal = new FormulaModal({model: sfModel, config:{viewTitle: "Formula"}});
            sfModal.render().then((formulaParameter)=> {
                this.model.attributes.CustomParameters.parameter[rowIdModel].Expression = formulaParameter;
            });
        }
        else {
            console.log('Select Field Modal Opened');
            
            this.model.set("dataSelectedItemId", this.model.attributes.CustomParameters.parameter[rowIdModel]._value, {silent:true});
            let sfModal = new SelectFieldModal({model: this.model, config:{viewTitle: "Select Field"}});
            sfModal.render().then((selectedField)=> {
                gridData[rowIdModel].source = selectedField.name;
                this.model.set('gridData', gridData,{silent:true});
                this.model.attributes.CustomParameters.parameter[rowIdModel]._value = selectedField.id;
                this.render();
            });
        }
    }

    itemCheck(e){
        this.model.unset('newRowAdded', constants.MODEL_SILENT);
        util.saveGridScrollPos(this.model);
        var i = $(e.currentTarget).closest('tr').index()-1;
        const rowData = $(this.gridEl).getRowData(i);

        if (!rowData['isDefault'] === true) {
            var gridData = this.model.get('gridData');

            if (e.currentTarget.checked) {
                gridData[i].formula = 'selected';
                gridData[i].source = '[Formula]';
                this.model.attributes.CustomParameters.parameter[i]._type = "expression";
                this.model.attributes.CustomParameters.parameter[i]._value = "";
            }
            else {
                gridData[i].formula = '';
                gridData[i].source = '';
                this.model.attributes.CustomParameters.parameter[i]._type = "field";
            }

            this.model.set('gridData', gridData, {silent: true});
            this.model.trigger('change');
            this.render();
        }
    }

    itemNew(){
        this.model.set('newRowAdded', true, constants.MODEL_SILENT);
        util.saveGridScrollPos(this.model);
        var gridData = this.model.get('gridData');
        var oldGridData = [...this.model.get('gridData')];
        let oldAttributes=[...this.model.attributes.CustomParameters.parameter];
        var updatedGridData,updatedAttributes;
        var newRow = {
            'name':'Parameter ' + (gridData.length+1) ,
            'source': '',
            'formula':  '',
            'isDefault': ''
        };
        // look for empty rows
        let emptyIndex = -1;
        let i =0;
        do {
            if (gridData[i].name === '' && gridData[i].source === '' && gridData[i].formula === ''
            && emptyIndex<0 ){
                emptyIndex = i;
            }
            ++i;
        } while (emptyIndex<0 && i <5);

        if (emptyIndex < 0) {
            $(this.gridEl).addRowData((gridData.length + 1), newRow);
            gridData.push(newRow);

        } else {
            newRow.name = 'Parameter ' + (emptyIndex+1) ;
            $(this.gridEl).setRowData(emptyIndex, newRow);
            $(this.gridEl).setSelection(newRow, true);
            gridData[emptyIndex]= newRow;
        }
        this.model.attributes.CustomParameters.parameter.push({_id: sequenceService.nextDomId() , _name: newRow.name, _type: 'field', _value: ''});
        this.model.set('gridData', gridData);
        updatedGridData=[...gridData];
        updatedAttributes=[...this.model.attributes.CustomParameters.parameter];
        this.model.set('newRowAdded', true, constants.MODEL_SILENT);
        this.render();

        undoService.add({
            undo:() =>{
                this.model.attributes.CustomParameters.parameter = oldAttributes;
                this.model.set('gridData',oldGridData,{silent:true});
                this.render();
            },
            redo:() =>{
                this.model.set('gridData',updatedGridData,{silent:true});
                this.model.attributes.CustomParameters.parameter=updatedAttributes;//
                this.render();
            }
        },textConstants.UNDO_CUSTOM_PARAMETER);
    }


    lastIndexOnGrid() {
        let gridData = $(this.gridEl).jqGrid('getGridParam', 'data');
        let index = gridData[gridData.length-1].id;
        return parseInt(index)
    }

    onLoadComplete() {
        var gridData = this.model.get('gridData');
        var isDefault = this.getColumnIndexByName('isDefault'),
            iColCheckbox = this.getColumnIndexByName('formula'),
            cRows = gridData.length,
            iRow, row, className;

        for (iRow = 0; iRow <= cRows; iRow++) {
            row = $(this.gridEl)[0].rows[iRow];
            className = row.className;

            if ($.inArray('jqgrow', className.split(' ')) > 0) {
                var value = $(this.gridEl).jqGrid('getCell', row.id, isDefault);

                if (value) {
                    $(row.cells[iColCheckbox]).children("input").prop("disabled", true);
                } else {
                    $(row.cells[iColCheckbox]).children("input").prop("disabled", false);
                }
            }
        }
    }


    setRow(rowid){
        super.setRow(rowid);
        const rowData = $(this.gridEl).getRowData(rowid);

        const isDefault = util.isTrue(rowData['isDefault']);

        $(this.gridEl).setColProp('name', {editable: (!isDefault)});
    }

    itemRemove(){
        util.saveGridScrollPos(this.model);
        const rowid = this.model.get('rowid');
        this.model.attributes.CustomParameters.parameter.splice(rowid,1);

        super.itemRemove();

        var gridData = this.model.get('gridData');
        if (gridData.length < 5) {
            var newRow = {
                'name':'',
                'source': '',
                'formula':  '',
                'isDefault': true
            };
            let rowIndex = this.lastIndexOnGrid()+1;
            $(this.gridEl).addRowData(rowIndex, newRow);

            // adjust background for odd rows
            $(this.gridEl + " tr").css("background", "");
            $(this.gridEl + " tr.jqgrow:odd").css("background", "#DDDDDC");
            gridData. push(newRow);
            this.model.set('gridData', gridData);
        }
    }

    saveCell(rowid, cellname, value){
        this.model.attributes.CustomParameters.parameter[rowid]._name = value;

        super.saveCell(rowid, cellname, value);
    }

    afterEditCell(rowId, cellName, value, iRow, iCol) {
        let self = this;
        $("#" + iRow + "_" + cellName).bind('blur', function () {
          $(self.gridEl).saveCell(iRow, iCol);
        });
      }
    
    remove(){
        $(window).off('resize');
        super.remove();
    }


}

export default MainCustomParametersView;
